import { getEmbedSearchWidgetIdFromPathname } from '#/modules/embedSearchWidget/utils/getEmbedSearchWidgetIdFromPathname';

import { hasIosUserAgent } from './hasIosUserAgent';

export function getAnalyticsApplicationContextProps() {
  const embedSearchWidgetId = getEmbedSearchWidgetIdFromPathname(
    window.location.pathname,
  );

  if (embedSearchWidgetId) {
    return {
      application_context: 'search-widget',
      embed_search_widget_id: embedSearchWidgetId,
    };
  }

  if (hasIosUserAgent())
    return {
      application_context: 'ios',
    };

  return {
    application_context: 'web',
  };
}
